<template>
  <div class="terms-container">
    <div class="z11 uppercase">COPYRIGHT & TRADEMARK</div>

    <p class="z11">
      Artfield.app, ("Artfield.app") respects the intellectual property rights of others and expects its users
      to do the same. It is Artfield.app’s policy, in appropriate circumstances and at its discretion, to disable
      and/or terminate the accounts of users who repeatedly infringe or are repeatedly charged with infringing the
      copyrights or other intellectual property rights of others, and to remove any infringing content from its
      web site when notified of such content as specified below.
    </p>

    <p class="z11">
      Please keep in mind the vast majority of content on Artfield.app is submitted by its users, which include a lot
      of creative professionals, both on the client (brands, magazines, press/public relations agents, etc.) and
      production side (photographers, ad agencies, etc.), which are in most cases either the copyright owners or
      authorized to distribute this content. Artfield.app does not have an automated way to verify the copyright
      claims of each user submitted content.
    </p>

    <p class="z11">
      In accordance with the Law of Industrial Property Law number 6769 and Law of Intellectual Property Rights number
      4846, Artfield.app will respond expeditiously to claims of copyright infringement committed using the Artfield.app
      website (the "Site") that are reported to Artfield.app’s Designated Copyright Agent, identified in the sample
      notice below.
    </p>

    <p class="z11">
      If you are a copyright owner, or are authorized to act on behalf of one, or authorized to act under any exclusive
      right under copyright, please report alleged copyright infringements taking place on or through the Site by
      completing the following Form and delivering it to <strong>contact@artfieldofficial.com</strong>. Upon receipt of
      the Form as described below, Artfield.app will take whatever action, in its sole discretion, it deems appropriate,
      including removal of the challenged material from the Site.
    </p>

    <div class="z11 uppercase">FORM</div>

    <p class="z11">
      Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered
      by this Notice - you may provide a representative list of the copyrighted works, or the brand/client owning the
      material that you claim have been infringed.
    </p>

    <p class="z11">
      Identify (i) the material that you claim is infringing (or to be the subject of infringing activity) and that is
      to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate
      the material, including at a minimum, if applicable, the URL of the link shown on the Site where such material may
      be found, and (ii) the reference or link, to the material or activity that you claim to be infringing, that is to
      be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate
      that reference or link, including at a minimum, if applicable, the URL of the link shown on the Site where such
      reference or link may be found.
    </p>

    <p class="z11">
      Provide your mailing address, telephone number, and, if available, email address.
    </p>

    <p class="z11">
      Include both of the following statements in the body of the Notice:
    </p>

    <p class="z11">
      "I hereby state that I have a good faith belief that the disputed use of the copyrighted material or reference or
      link to such material is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use)."
    </p>

    <p class="z11">
      "I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner,
      or authorized to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is
      allegedly infringed."
    </p>

    <p class="z11">
      Provide your full legal name and your electronic or physical signature.
    </p>

    <p class="z11">
      Send this Notice, with all items completed, to <strong>contact@artfieldofficial.com</strong>.
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  console.log('Terms of Service page loaded.');
});
</script>

<style scoped>
.z11:first-child {
  font-size: 20px;
}
.z11 {
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
}

.uppercase {
  text-transform: uppercase;
  margin-top: 20px;
  line-height: 20px;
  letter-spacing: .4px;
}
</style>
